'use client'
const DEFAULT_WAAS_API_URL = 'https://app.dynamicauth.com/api/v0';

export { DEFAULT_WAAS_API_URL };
